import React from "react";
import "./Team.css";

import Jacky from "../assets/jacky final.png";
import Mabel from "../assets/mabelc.png";
import Katie from "../assets/Katie.png";
import Stefan from "../assets/stefan.png";
import Tao from "../assets/Tao.png";
import Ian from "../assets/ian.png";
import Sid from "../assets/sid.png";
import Ela from "../assets/Ela.png";
import Siraj from "../assets/siraj .png";

/* Credential logos */
import amazon from "../assets/amazon-dark.png";
import bmw from "../assets/bmw.png";
import meta from "../assets/meta-dark.png";
import cambridge from "../assets/cambridge-white.png";
import oxford from "../assets/oxford-white.png";

const team = [
  {
    name: "Jacky",
    role: "Founder & CEO",
    signal: "BMW · AMEX · Ex-Founder, Top 4 Alibaba",
    image: Jacky,
    position: "center 22%",
  },
  {
    name: "Mabel",
    role: "Co-Founder & COO",
    signal: "Amazon · London Stock Exchange · Interim Head",
    image: Mabel,
    position: "center 18%",
  },
  {
    name: "Dr. Siraj",
    role: "Science & Growth",
    signal: "Neuroscience · Cambridge Dr · GP",
    image: Siraj,
    position: "center 18%",
  },
  {
    name: "Dr. Katie",
    role: "Product",
    signal: "Oxford Physics · 10+ Years EXP",
    image: Katie,
    position: "center 20%",
  },
  {
    name: "Stefan",
    role: "AI / ML",
    signal: "International Olympian in Informatics",
    image: Stefan,
    position: "center 18%",
  },
  {
    name: "Siddharth",
    role: "Data",
    signal: "London Stock Exchange · Senior Manager (Data)",
    image: Sid,
    position: "center 18%",
  },
  {
    name: "Tao",
    role: "AI / ML",
    signal: "Meta · Imperial Top 1%",
    image: Tao,
    position: "center 18%",
  },
  {
    name: "Ian",
    role: "Robotics",
    signal: "YC Summer · #1 EU Defense Hackathon",
    image: Ian,
    position: "center 18%",
  },
];

const teamLogos = [
  amazon,
  meta,
  bmw,
  cambridge,
  oxford,
];

export default function Team() {
  return (
    <main className="wTeamPage">

      <section className="wTeamSection">

        {/* ========================================
            CREDENTIALS
            ======================================== */}

        <div className="wTeamCredentials">

          <p className="wTeamCredentials__label">
            Built by leaders from
          </p>


          <div className="wTeamCredentials__row">

            {teamLogos.map((logo, index) => (
              <div
                className="wTeamCredentials__logo"
                key={`team-logo-${index}`}
              >
                <img
                  src={logo}
                  alt=""
                />
              </div>
            ))}


            <span className="wTeamCredentials__more">
              and more...
            </span>

          </div>

        </div>


        {/* ========================================
            TEAM GRID
            ======================================== */}

        <div className="wTeamGrid">

          {team.map((person) => (
            <article
              className="wTeamCard"
              key={person.name}
            >

              <img
                className="wTeamCard__image"
                src={person.image}
                alt={person.name}
                style={{
                  objectPosition:
                    person.position || "center top",
                }}
              />


              <div className="wTeamCard__gradient" />


              <div className="wTeamCard__content">

                <h2>
                  {person.name}
                </h2>

                <p className="wTeamCard__role">
                  {person.role}
                </p>

                <p className="wTeamCard__signal">
                  {person.signal}
                </p>

              </div>

            </article>
          ))}

        </div>

      </section>

    </main>
  );
}